"use client";

import { forwardRef, type CSSProperties } from "react";
import { login } from "@/lib/api";

type Props = {
  label?: string;
  className?: string;
  style?: CSSProperties;
  email?: string;
  password?: string;
};

const LoginButton = forwardRef<HTMLButtonElement, Props>(function LoginButton({ label = "Login with email/password", className, style, email, password }, ref) {
  async function handleLogin() {
    // If email and password are provided, use API login
    if (email && password) {
      try {
        const response = await login(email, password);
        console.log('Login response:', response);
        
        // Store token if provided in response
        if (response.access_token) {
          localStorage.setItem('access_token', response.access_token);
        }

        // Identify user in Heap if id is available
        try {
          const userId = response.user?.id || response.user_id || response.id;
          if (userId && typeof window !== 'undefined' && window.heap?.identify) {
            window.heap.identify(String(userId));
            if (window.heap.addUserProperties) {
              window.heap.addUserProperties({ email });
            }
          }
        } catch {}
        
        // Redirect to home or appropriate page
        window.location.href = '/';
      } catch (error) {
        console.error('Login failed:', error);
        alert('Login failed. Please check your credentials.');
      }
    }
  }
  
  return (
    <button ref={ref} type="button" onClick={handleLogin} className={className} style={style}>
      {label}
    </button>
  );
});

export default LoginButton;